import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import NavBar from "../NavBar";
import API_BASE_URL from "../../config";
import { FaUser, FaEnvelope, FaWhatsapp, FaUniversity, FaCalendarAlt } from "react-icons/fa";
import "../Styles/JoinPage.css";
import techstrikeLogo from "../../Assets/logo_rm.png";

const JoinPage = () => {
  const { name } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    whatsapp: "",
    faculty: "",
    year: "",
    reason: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name: formData.fullName,
        email: formData.email,
        phone: formData.whatsapp,
        subPillar: name, // from useParams
        faculty: formData.faculty,
        year: formData.year,
        reason: formData.reason
      };

      const response = await fetch(`${API_BASE_URL}/api/applications`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        alert("Your application has been submitted. The admin will review it.");
        navigate("/");
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.log(error);
      alert("Server error. Please try later.");
    }
  };

  return (
    <div className="join-container-adv">
      <NavBar />
      <motion.div
        className="join-card"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="logo-container">
          <img src={techstrikeLogo} alt="Techstrike Logo" className="techstrike-logo" />
        </div>
        <h1 className="join-title">Join <span>{name}</span></h1>
        <p className="join-description">
          Become a part of the <strong>{name}</strong> sub-pillar. Fill the form below to get started!
        </p>

        <form className="join-form-adv" onSubmit={handleSubmit}>
          <div className="input-group">
            <FaUser className="input-icon" />
            <input name="fullName" type="text" placeholder="Full Name" required onChange={handleChange} />
          </div>

          <div className="input-group">
            <FaEnvelope className="input-icon" />
            <input name="email" type="email" placeholder="Email Address" required onChange={handleChange} />
          </div>

          <div className="input-group">
            <FaWhatsapp className="input-icon" />
            <input name="whatsapp" type="text" placeholder="WhatsApp Number" required onChange={handleChange} />
          </div>

          <div className="input-group">
            <FaUniversity className="input-icon" />
            <select name="faculty" required onChange={handleChange}>
              <option value="">Select Faculty</option>
              <option value="Engineering & Technology">Faculty of Engineering & Technology</option>
              <option value="Management & Social Sciences">Faculty of Management & Social Sciences</option>
              <option value="Health Sciences">Faculty of Health Sciences</option>
              <option value="Maritime Sciences">Faculty of Maritime Sciences</option>
              <option value="Marine Engineering">Faculty of Marine Engineering</option>
              <option value="Computing">Faculty of Computing</option>
              <option value="Humanity & Education">Faculty of Humanity and Education</option>
            </select>
          </div>

          <div className="input-group">
            <FaCalendarAlt className="input-icon" />
            <select name="year" required onChange={handleChange}>
              <option value="">Year of Study</option>
              <option value="1st Year">1st Year</option>
              <option value="2nd Year">2nd Year</option>
              <option value="3rd Year">3rd Year</option>
              <option value="4th Year">4th Year</option>
            </select>
          </div>

          <div className="input-group">

            <textarea
              name="reason"
              placeholder="Why do you want to join?"
              rows="4"
              required
              onChange={handleChange}
            ></textarea>
          </div>

          <motion.button whileHover={{ scale: 1.05 }} className="submit-btn-adv" type="submit">
            Submit Application
          </motion.button>
        </form>
      </motion.div>

    </div>
  );
};

export default JoinPage;
